import React from 'react';
import {
  useFormContext,
  RegisterOptions,
} from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { INPUT_REGEX } from 'src/utilities/regexPatterns';

export interface BaseCorpNameProps {
  name: string;
  id: string;
  label?: string;
  rules?: RegisterOptions;
}

export const BaseCorpName: React.FC<BaseCorpNameProps> = ({
  name,
  id,
  label = 'Firm Name *',
  rules = {},
}) => {
  const { errors, control } = useFormContext();

  const isEmptyValue = (value: string): boolean | string =>
    value.trim() !== '' || 'Client Name must be filled out';

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      maxLength={50}
      control={control}
      error={errors[name]}
      aria-label={label}
      inputSize="medium"
      blockWidth
      label={label}
      placeholder="e.g. Acme Corporation"
      rules={{
        required: 'Client Name is required',
        pattern: {
          value: INPUT_REGEX,
          message: ' Client Name is invalid',
        },
        validate: {
          isEmpty: isEmptyValue,
        },
        ...rules,
      }}
    />
  );
};
